export default __webpack_public_path__ + "static/media/Certificate_9.91237fd1.jpg";